import Button from "../../../../components/FormComponents/Button";
import Input from "../../../../components/FormComponents/Input";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";

const RoleFormModal = ({ isOpen, onClose, form, isEdit, onChange, onSubmit }) => {
  return (
    <BuilderModal isOpen={isOpen} onClose={onClose} modalName={isEdit ? "Edit Role" : "Create Role"}>
      <div className="flex_column gap_2">
        <Input
          label="Role Name"
          placeholder="Admin"
          value={form.name}
          onChange={(e) => onChange("name", e.target.value)}
        />

        <Input
          label="Role Code"
          placeholder="ADMIN"
          value={form.role_code}
          onChange={(e) => onChange("role_code", e.target.value)}
        />

        <Input
          label="Description"
          placeholder="Short description"
          value={form.description}
          onChange={(e) => onChange("description", e.target.value)}
        />

        <div className="d_flex w_100 gap_2 justify_end">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button variant="primary" onClick={onSubmit} style={{ marginLeft: "0" }}>
            {isEdit ? "Update Role" : "Create Role"}
          </Button>
        </div>
      </div>
    </BuilderModal>
  );
};

export default RoleFormModal;
